import { getIdOrNull, inEnum } from '..'
import { Properties } from '../entities'
import Clonable from './clonable'
import { ConstraintType } from './constraintType'
import { InternshipFileTypes } from './internshipRequestFile'
import { StudentProperties } from './student'

export const InstitutionConstraintProperties = Object.freeze({
  ID: Properties.ID,
  CONSTRAINT_TYPE: Properties.CONSTRAINT_TYPE,
  ENABLE: Properties.ENABLE,
  ENTITY_NAME: Properties.ENTITY_NAME,
  PROPERTY_NAME: Properties.PROPERTY_NAME,
  TYPE: Properties.TYPE,
})

export const StudentMetadata = new Set([
  ...Object.values(StudentProperties),
  'externalId',
  'profilePictureName'
])
export const InternshipDocumentMetadata = new Set([InternshipFileTypes.CONVENTION.toLowerCase()])

export const EntityNames = Object.freeze({
  STUDENT: 'Student',
  INTERNSHIP_DOCUMENT: 'InternshipDocument'
})

export const PropertyNames = Object.freeze({
  [EntityNames.STUDENT]: StudentMetadata,
  [EntityNames.INTERNSHIP_DOCUMENT]: InternshipDocumentMetadata
})

export const InstitutionConstraintValidators = Object.freeze({
  [Properties.ENTITY_NAME]: c => inEnum(EntityNames, c[Properties.ENTITY_NAME]),
  [Properties.PROPERTY_NAME]: c => inEnum(EntityNames, getEntityFromProperty(c[Properties.PROPERTY_NAME])),
  [Properties.INSTITUTION]: c => getIdOrNull(c[Properties.INSTITUTION]) !== null
})

export const getEntityFromProperty = propertyName => {
  const entityName = Object
    .keys(PropertyNames)
    .find(entityName => PropertyNames[entityName].has(propertyName))

  return entityName
}

export class InstitutionConstraint extends Clonable {
  constructor({ id = -1, constraintType = new ConstraintType(), enable = true, entityName, institution, propertyName, type } = {}) {
    super()
    this.id = id
    this.constraintType = getIdOrNull(constraintType)
    this.enable = enable
    this.entityName = entityName
    this.institution = getIdOrNull(institution)
    this.propertyName = propertyName
    this.type = type ?? constraintType.type
  }
}